import { Component, Input, Inject, OnInit } from 'ng-metadata/core';
import { PasswordStrengthService } from './password-strength.service';
import './password-strength.component.scss';

@Component({
    selector: 'mw-password-strength',
    template: `
        <md-progress-linear ng-class="[ $ctrl.passwordStrengthClass ]" md-mode="determinate" value="{{ $ctrl.passwordStrength }}"></md-progress-linear>
        <span class="mw-password-strength__label" translate="{{ $ctrl.passwordStrengthLabel }}"></span>
    `
})
export class PasswordStrengthComponent {
    @Input('<') passwordStrength: number;
    @Input('<') password: string;

    private isUsingCustomStrength: boolean;

    constructor(@Inject('mwPasswordStrengthService') private passwordStrengthService: PasswordStrengthService,
                @Inject('$attrs') private $attrs) {
                    if (this.$attrs.passwordStrength) {
                        this.isUsingCustomStrength = true;
                    }
    }

    ngOnChanges(changes): void {
        if (!this.isUsingCustomStrength && changes.password.previousValue !== changes.password.currentValue) {
            this.passwordStrength = this.passwordStrengthService.getPasswordStrength(this.password);
        }
    }

    get passwordStrengthClass(): string {
        return 'mw-password-strength__value--' + this.passwordStrength;
    }

    get passwordStrengthLabel(): string {
        let strengthLabelBEMModifier = 'very-strong';

        if (this.passwordStrength < 25) {
            return 'mw-password-strength__length-message';
        } else if (this.passwordStrength < 50) {
            strengthLabelBEMModifier = 'weak';
        } else if (this.passwordStrength < 75) {
            strengthLabelBEMModifier = 'reasonable';
        } else if (this.passwordStrength < 100) {
            strengthLabelBEMModifier = 'strong';
        }

        return 'mw-password-strength__' + strengthLabelBEMModifier;
    }

}


// WEBPACK FOOTER //
// ./src/lib/components/form/password-strength/password-strength.component.ts